<template>
  <div>
    <label class="formLabel" :for="`author-items-${_uid}`"> {{ label }}</label>
    <div
      class="formSearch"
      :class="{ 'has-Error': required && ids.length === 0 }"
      v-if="multiple || (!multiple && authorSelection.length === 0)"
    >
      <form autocomplete="off" class="formSearch__InputWrapper" @keydown.enter.prevent="onEnter">
        <icon class="formSearch__Icon" name="search"></icon>
        <p class="formSearch__Loader" v-if="loading">{{ $store.getters.getStringTranslation('loading') }}...</p>
        <input
          :id="`author-items-${_uid}`"
          class="formInput--Search"
          type="text"
          @keyup="search.length > 2 || search.length === 0 ? getAuthorOptions() : null"
          @click="getAuthorOptions()"
          @focus="focused = true"
          @blur="focused = false"
          v-model="search"
          :placeholder="$store.getters.getStringTranslation('searchByName')"
        />
      </form>
      <ul class="formSearch__List" :class="{ 'is-Active': focused === true }" v-if="authorOptions !== undefined">
        <li class="formSearch__ListItem" v-for="author in authorOptions" :key="author.id">
          <span @click="pushAuthor(author)">{{ getTitle(author) }}</span>
        </li>
        <li class="formSearch__ListItem" v-if="noResults === true">
          <span>{{ $store.getters.getStringTranslation('noAuthorsFound') }}</span>
        </li>
        <li class="formSearch__ListItem" v-else-if="authorOptions.length === 0">
          <span>{{ $store.getters.getStringTranslation('loading') }}...</span>
        </li>
      </ul>
    </div>

    <ul
      class="modal__BuilderResources"
      :class="{ 'modal__BuilderResources--Slim': multiple === false }"
      v-if="authorSelection.length > 0 && loadingSelection === false"
    >
      <li class="modal__BuilderResourcesItem" v-for="(author, index) in authorSelection" :key="author.id">
        <template v-if="multiple">
          <button type="button" class="modal__BuilderResourcesIcon" @click="moveAuthor(index, index - 1)">
            <icon name="arrow-up"></icon>
          </button>
          <button type="button" class="modal__BuilderResourcesIcon" @click="moveAuthor(index, index + 1)">
            <icon name="arrow-down"></icon>
          </button>
        </template>
        <span>{{ getTitle(author) }}</span>
        <button type="button" class="modal__BuilderResourcesIcon--Delete" @click="removeAuthor(author)">
          <icon weight="regular" name="times"></icon>
        </button>
      </li>
    </ul>
    <p class="loader--Authors" v-else-if="loadingSelection === true">
      {{ $store.getters.getStringTranslation('loading') }}...
    </p>
  </div>
</template>

<script>
import debounce from 'tiny-debounce'
import HTTP from '@/http-common.js'

export default {
  props: {
    label: {
      type: String,
      default: 'Authors',
    },
    types: {
      type: Array,
      default: function () {
        return []
      },
    },
    lang: {
      type: String,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    authors: {},
    apiKeys: {
      type: Array,
      default: function () {
        return []
      },
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  name: 'SearchAuthor',
  data() {
    return {
      search: '',
      ids: [],
      authorSelection: [],
      authorOptions: [],
      loading: false,
      loadingSelection: false,
      noResults: false,
      focused: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.accounts.user
    },
  },
  watch: {
    ids() {
      if (this.multiple) {
        this.$emit('input', this.ids)
        this.$emit('change', this.authorSelection)
      } else {
        this.$emit('input', this.ids[0])
        this.$emit('change', this.authorSelection[0])
      }
    },
  },
  methods: {
    getTitle(author) {
      if (author) return author.name
      return null
    },

    // Author actions
    getAuthorOptions: debounce(function () {
      this.loading = true
      let limit = null
      if (this.search.length === 0) limit = 10

      this.loading = true
      HTTP.post('search/author', {
        api_keys: this.apiKeys,
        search_query: this.search,
        types: this.types,
        org_id: this.user.org_id,
        limit,
      }).then((response) => {
        this.loading = false
        this.authorOptions = response.data.authors.filter(
          (a) => this.authorSelection.map((b) => b.id).indexOf(a.id) === -1
        ) // Don't show options that are already selected

        if (this.authorOptions.length === 0) {
          this.noResults = true
        } else {
          this.noResults = false
        }
      })
    }, 500),

    pushAuthor(author) {
      this.ids.push(author.id)
      this.authorSelection.push(author)

      const index = this.authorOptions.findIndex((x) => x.id === author.id)
      this.authorOptions.splice(index, 1)
      this.search = ''
    },

    removeAuthor(author) {
      this.authorOptions.push(author)

      const index = this.authorSelection.findIndex((x) => x.id === author.id)
      this.ids.splice(index, 1)
      this.authorSelection.splice(index, 1)
    },

    moveAuthor(indexA, indexB, arr = this.authorSelection) {
      arr.splice(indexB, 0, arr.splice(indexA, 1)[0])
    },
  },
  mounted() {
    if (this.authors) {
      if (typeof this.authors === 'object' && !Array.isArray(this.authors)) {
        this.authorSelection = [this.authors]
        this.ids = [this.authors.id]
      } else if (this.authors && this.authors.length > 0 && typeof this.authors[0] === 'object') {
        this.authorSelection = this.authors
        this.ids = this.authors.map((author) => author.id)
      } else if (this.authors && this.authors.length > 0 && typeof this.authors[0] === 'number') {
        this.ids = this.authors
        this.authors.forEach((id) => {
          this.loadingSelection = true
          HTTP.get(`author/${id}`).then((response) => {
            this.authorSelection.push(response.data)
            this.loadingSelection = false
          })
        })
      }
    }
  },
}
</script>
